import {SingleViewDispatcher} from '../core/dispatchers'
import {ISingleViewDispatcher} from '../core/interfaces/dispatchers'

class AppSingleViewDispatcher extends SingleViewDispatcher {}

export const appSingleViewDispatcher = new AppSingleViewDispatcher() as ISingleViewDispatcher
